<template>
  <div v-if="results" class="result-container ">
    <div class="experience-side">
      <router-link
        :to="{ name: 'game-home' }"
        class="btn primary square"
        v-tooltip="{ content: 'Retourner à l\'accueil', placement: 'right' }"
      >
        <i class="yuzu-icon arrow-back" />
      </router-link>
      <div class="experience-image-container">
        <img
          class="experience-image"
          src="@/assets/images/img/experience-image.webp"
          alt="Image d'une expérience Yuzu"
        />
      </div>
      <div class="experience-content-container">
        <div class="experience-content-title">Votre expérience Yuzu</div>
        <div class="experience-content-description">
          <p>
            Votre <b>session Yuzu</b> est maintenant terminée et nous espérons
            que tout s’est bien déroulé de votre côté.
          </p>
          <p>
            L’expérience que vous venez de vivre a été coconstruite en
            partenariat avec un
            <b>laboratoire de psychologie et de neurosciences</b>
            afin de vous garantir des résultats fiables sur les différentes
            compétences évaluées.
          </p>
          <p>
            Si, à la lecture de vos résultats, il vous reste des questions, n’hésitez pas à nous contacter.
          </p>
          <p>L’équipe Yuzu.</p>
        </div>
        <div class="result-information">
          <img class="result-icon" alt="Icon" src="@/assets/images/icon/info.svg" />
          <p class="result-information-text">
            <span class="text-wrapper">Pour information</span>
            <span class="span">
              : ce bilan ne contient pas les mêmes informations que le rapport d'évaluation complet et détaillé reçu par l'organisation.
            </span>
          </p>
        </div>
        <div class="experience-content-images">
          <div class="mask-image">
            <img src="/images/thumbnail/adpt.webp" alt="Gameplay Yuzu" />
          </div>
          <div class="mask-image">
            <img src="/images/thumbnail/gdss.webp" alt="Gameplay Yuzu" />
          </div>
          <div class="mask-image">
            <img src="/images/thumbnail/rdpb.webp" alt="Gameplay Yuzu" />
          </div>
        </div>
      </div>
    </div>
    <div class="results-side">
      <component v-if="grades" :is="currentProfileComponent"  :grades="grades"/>
    </div>
  </div>
</template>

<script setup>
import { computed } from "vue";
import { useAssessmentStore } from "@/stores/assessment.js";
import { storeToRefs } from "pinia";
import { useRouter } from "vue-router";

//Different profils
import ArchitectProfil from '@/views/game/results/profil_architect.vue';
import InventorProfil from '@/views/game/results/profil_inventor.vue';
import MinesweeperProfil from '@/views/game/results/profil_minesweeper.vue';
import PilotProfil from '@/views/game/results/profil_pilot.vue';
import NavigatorProfil from '@/views/game/results/profil_navigator.vue';
import BalancerProfil from '@/views/game/results/profil_balancer.vue';

const assessmentStore = useAssessmentStore();
const { assessments, results } = storeToRefs(assessmentStore);

const router = useRouter();

if (assessments.value.length === 0) {
  await assessmentStore.getCandidateAssessments();
}

if (!results.value) router.push({ name: "game-home" });

// Get score and grade for the three modules
var gdss_score = 0;
var gdss_grade = 0;
var adpt_score = 0;
var adpt_grade = 0;
var rdpb_score = 0;
var rdpb_grade = 0;

for (let index = 0; index < results.value.length; index++) {
  const element = results.value[index];
  switch (element.module) {
    case "MS_RDPB":
      rdpb_score = element.score;
      rdpb_grade = element.grade;
      break;
    case "MS_GDSS":
      gdss_score = element.score;
      gdss_grade = element.grade;
      break;
    case "MS_ADPT":
      adpt_score = element.score;
      adpt_grade = element.grade;
      break;  
    default:
      break;
  }  
}

const grades = {
  'gdss_grade': gdss_grade,
  'adpt_grade': adpt_grade,
  'rdpb_grade': rdpb_grade,
};

var currentProfile = 'None';

if(rdpb_score >= gdss_score && gdss_score >= adpt_score) {
  //Architect Profil
  currentProfile = 'architect';
}
else if(rdpb_score >= adpt_score && adpt_score >= gdss_score) {
  //Inventor Profil
  currentProfile = 'inventor';
}
else if(gdss_score >= rdpb_score && rdpb_score >= adpt_score) {
  //Minesweeper Profil
  currentProfile = 'minesweeper';
}
else if(gdss_score >= adpt_score && adpt_score >= rdpb_score) {
  //Pilot  Profil
  currentProfile = 'pilot';
}
else if(adpt_score >= rdpb_score && rdpb_score >= gdss_score) {
  //Navigator  Profil
  currentProfile = 'navigator';
}
else if(adpt_score >= gdss_score && gdss_score >= rdpb_score) {
  //Balancer Profil
  currentProfile = 'balancer';
}

const currentProfileComponent  = computed(() => { 
  switch (currentProfile) {
    case 'architect':
      return ArchitectProfil;
    case 'inventor':
      return InventorProfil;
    case 'minesweeper':
      return MinesweeperProfil;
    case 'pilot':
      return PilotProfil;
    case 'navigator':
      return NavigatorProfil;
    case 'balancer':
      return BalancerProfil;
    default:
      return null;
  }
});
</script>

<style>
.result-container  {
  display: flex;
  height: 100vh;
  overflow: hidden;
  @media screen and (max-width:  1100px) {    /*TODO import from variables.scss*/
    display: block;
    height: 100vh;
    overflow: auto;
  }
}

.result-information {
  align-items: center;
  background-color: #2c2b27;
  border: 1px solid;
  border-color: #f2cb36;
  border-radius: 6px;
  display: flex;
  gap: min(1.5svh, 16px);;
  padding: min(1.5svh, 16px);;
  margin-top: auto;
  font-family: "Bio Sans-Bold", Helvetica;
}

.result-information .icon {
  height: 22px;
  position: relative;
  width: 22px;
}

.result-information .result-information-text {
  color: #ffffff;
  flex: 1;
  font-size: min(2svh, 18px);
  font-weight: 400;
  letter-spacing: 0;
  line-height: normal;
  margin-top: -1px;
  position: relative;
}

.result-information .text-wrapper {
  font-weight: 700;
}

</style>